import { Box, FormControl, FormLabel, Switch, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';

const CommonSwitchInput = ({
  labelText,
  name,
  register,
  errors,
  isValidate = true,
  defaultChecked = false,
  textColor,
  brandStars,
  isDisabled = false,
  control,
}) => {
  return (
    <Box mt={4}>
      <FormControl display="flex" alignItems="center">
        <Controller
          name={name}
          control={control}
          defaultValue={defaultChecked}
          render={({ field: { onChange, value } }) => (
            <Switch
              id={name}
              name={name}
              isChecked={value}
              onChange={onChange}
              {...register}
              isDisabled={isDisabled}
              size="md"
              mr={3}
              sx={{
                'span.chakra-switch__track[data-checked]': {
                  backgroundColor: '#203946',
                },
              }}
            />
          )}
        />
        <FormLabel
          htmlFor={name}
          fontSize="sm"
          fontWeight="500"
          color={textColor}
          mb="0"
        >
          {labelText}
          {isValidate && (
            <Text as="span" color={brandStars}>
              {' '}
              *
            </Text>
          )}
        </FormLabel>
      </FormControl>
      {errors && (
        <Text color="red" fontSize="sm">
          {errors.message}
        </Text>
      )}
    </Box>
  );
};

CommonSwitchInput.propTypes = {
  labelText: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  register: PropTypes.object,
  errors: PropTypes.object,
  isValidate: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  textColor: PropTypes.string,
  brandStars: PropTypes.string,
  isDisabled: PropTypes.bool,
  control: PropTypes.object,
};

export default CommonSwitchInput;
